import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumsMakeAPaymentGenerator = generator(({ i18n }: GeneratorArgs) => {
  const createpremiumsMakeAPaymentLinkClickHandler = (elementId: string) => (
    params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.Premiums,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    premiums_makeapayment_otherwaystopay_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_otherwaystopay_click'
    ),
    premiums_makeapayment_setupeasypay_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_setupeasypay_click'
    ),
    premiums_makeapayment_easypaypage_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_easypaypage_click'
    ),
    premiums_makeapayment_checkhistory_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_checkhistory_click'
    ),
    // premiums_makeapayment_paythroughpaygov_click: createpremiumsMakeAPaymentLinkClickHandler(
    //   'premiums_makeapayment_paythroughpaygov_click'
    // ),
    premiums_makeapayment_premiumbillcms_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_premiumbillcms_click'
    ),
    premiums_makeapayment_findouthowyoupay_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_findouthowyoupay_click'
    ),
    premiums_makeapayment_visitssaccount_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_visitssaccount_click'
    ),
    premiums_makeapayment_backtopremiums_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_makeapayment_backtopremiums_click'
    ),
    premiums_paymenthistory_makeapayment_click: createpremiumsMakeAPaymentLinkClickHandler(
      'premiums_paymenthistory_makeapayment_click'
    ),
    premiums_makeapayment_whatsanhsa_hover: {
      core: {
        elementId: 'premiums_makeapayment_whatsanhsa_hover',
        property: 'MAX',
        activity: Activity.ToolTipRead,
        component: Component.Premiums,
        coreClickData: {
          linkText: i18n.t('payYourPremium.hsaTooltip.trigger', { ns: 'makeApaymentPage' })
        }
      }
    },
    premiums_makeapayment_print_click: {
      core: {
        elementId: 'premiums_makeapayment_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_makeapayment_onlinelivechat_click: {
      core: {
        elementId: 'premiums_makeapayment_onlinelivechat_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        coreClickData: {
          linkText: i18n.t('ineligibleAlert.deferred', { ns: 'makeAPaymentPage' })
        }
      }
    },
    premiums_makeapayment_paythroughpaygov_click: {
      core: {
        elementId: 'premiums_makeapayment_paythroughpaygov_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        coreClickData: {
          linkText: i18n.t('payYourPremium.form.submit', { ns: 'makeAPaymentPage' })
        }
      }
    }
  }
})

export type premiumsMakeAPaymentKeys = keyof ReturnType<
  typeof premiumsMakeAPaymentGenerator
>

export default premiumsMakeAPaymentGenerator
